import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { IUpdateBankDetails } from 'Interfaces/updateBankDetails';
import { UpdateBankDetailsSchema } from 'Modules/Requests/UpdateBankDetails/Schema';
import { useState } from 'react';

export const useBankDetailsForm = () => {
  const [bankNumber, setBankNumber] = useState<number | undefined>(undefined);
  const [branchNumber, setBranchNumber] = useState<number | undefined>(
    undefined
  );

  const bankDetailsForm = useForm<IUpdateBankDetails>({
    mode: 'onBlur',
    resolver: yupResolver(UpdateBankDetailsSchema(bankNumber, branchNumber)),
    defaultValues: {
      bankId: undefined,
      branchId: undefined,
      accountNum: undefined,
    },
  });

  return {
    bankDetailsForm,
    setBankNumber,
    setBranchNumber,
  };
};
